import Modal from '../../../shared/Modal';
import ButtonLoadingContent from '../../../shared/Loading/ButtonLoadingContent';

const DeleteModal = ({
  confirm,
  closeActive,
  onClose,
  onConfirm,
  warningMessage = '',
}) => {
  return (
    <Modal
      isOpen={confirm.open}
      onClose={onClose}
      title="Confirmar eliminación"
      closeActive={closeActive}
    >
      {(close) => (
        <div className="p-6 space-y-5">
          <p className="text-gray-700">{confirm.message}</p>
          {warningMessage && (
            <p className="text-sm text-gray-900">
              {warningMessage}
            </p>
          )}
          {confirm.error && (
            <p className="text-sm text-red-600">Error: {confirm.error}</p>
          )}
          <div className="flex justify-end gap-2">
            <button
              type="button"
              onClick={close}
              className="px-4 py-2 border border-gray-300 text-gray-700 hover:bg-gray-50 rounded"
            >
              Cancelar
            </button>
            <button
              type="button"
              onClick={onConfirm}
              disabled={confirm.loading}
              className={`min-w-[5.5rem] px-4 py-2 text-white rounded ${
                confirm.loading ? 'bg-red-300 cursor-wait' : 'bg-red-600 hover:bg-red-700'
              }`}
            >
              <ButtonLoadingContent loading={confirm.loading}>
                Eliminar
              </ButtonLoadingContent>
            </button>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default DeleteModal;
